module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABU0lEQVQ4jbXUP0scYRDH8c9eBEExpE8jIsEyhZBKwbwDQWx9C6aQFBbHg5AYA5IuVZqkTZFGISKEFNaWEhFNYRcuYGOEYMbinuMOkV3dNT9YZp95Zr7PMM+fIiJkjeIUj9TTbzxOKV3A0MDEOVIDcKcHhWKg4lpKKd3o74Hn0W60Ql+bKaWPvVZ0cILiHsC/+M+teIINjDdaoa9jrBQRsY8JfMe/htAW5nBQRLcXr7Bah3S9Fe12ex0rrTz+W5L7FjMD4xmslcRfoNUqCaB7gRaxjWd4jq/ZV6oq8CVeYwQ7+IJhvGkKnsL7HPcQY/n/AybLEofKJnGA6Qx8l33LOMNRE/AmXlzzfct2Ay/rgrf127WQ7edst8oSq8C7+YOn2S5X5KB682qrquJB7ekevzuBb/Nc3vbKP6D7uv3Mjk93qagEuoQ/ImIuIg7j/vQjImavAFfjqRUawUXfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caiwuguanli.png
// module id = UgmO
// module chunks = 1